/* ------------------------------------------------
   leva → euro helper
   ------------------------------------------------ */
const BGN_TO_EUR  = 1.95583;
const BGN_PATTERN = /([\d\s,.]+)\s?лв\.?/i;   // one match, no “g”

const TARGET_SELECTORS = [
  '.price',
  '.cart__totals .totals__subtotal-value',
  '.cart-item__old-price',
  '.cart-item__final-price',
  '.cart-item__details .product-option',
  '.unit-price',
].join(', ');

function addEuroPrices(root = document) {
  root.querySelectorAll(TARGET_SELECTORS).forEach(el => {
    if (el.dataset.eurAdded) return;                 // already converted

    const match = el.textContent.match(BGN_PATTERN);
    if (!match) return;

    const leva = parseFloat(match[1].replace(/\s/g,'').replace(',','.'));
    if (isNaN(leva)) return;

    const euro = (leva / BGN_TO_EUR).toFixed(2);

    const span = document.createElement('span');
    span.style.cssText = 'font-size:1em;color:white';
    span.textContent   = ` | ${euro} €`;

    el.appendChild(span);
    el.dataset.eurAdded = 'true';
  });
}

/* first run + every dynamic update ----------------*/
document.addEventListener('DOMContentLoaded', () => {
  addEuroPrices();                                   // 1) first paint

  /* 2) Dawn / Sense / most modern themes dispatch this
        event whenever the cart HTML is re-rendered      */
  document.addEventListener('cart:updated', () => addEuroPrices());

  /* 3) safety net – watch for any other Ajax content  */
  new MutationObserver(() => addEuroPrices())
      .observe(document.body, {childList:true, subtree:true});
});